import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { toast } from "react-toastify";
import {
    createAPIBankingTransaction,
    EndpointBankingTransaction,
} from "../../Services/BankingTransaction/BankingTransactionService";
import storage from "../../Services/Storage";
import Loader from "../../Components/Loader";
// import { createGlobalStyle } from "styled-components";
import { format } from "date-fns";

const BankingTransactionDetails = () => {
    const [bankDetailsData, setBankDetailsData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loadigndt, setLoadigndt] = useState(false);
    const [filteredBanksData, setFilteredBanksData] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null);
    const [bouncedChequeList, setBouncedChequeList] = useState([]);
    const [selectBankrecptData, setSelectBankrecptData] = useState([]);
    const [selectBankChqData, setSelectBankChqData] = useState([]);
    const [newDepositChequeList, setNewDepositChequeList] = useState([]);
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [transactionDate, setTransactionDate] = useState(new Date());
    const auth = storage.getLocal("user");
    const [tabIndex, setTabIndex] = useState(0);

    const getPopulateBankDetailsData = async () => {
        try {
            setLoader(true);
            const response = await createAPIBankingTransaction().get(
                `${EndpointBankingTransaction.PopulateBankDetailsData}?CompId=${auth.CompId}`
            );
            setBankDetailsData(response.data.Data ?? []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const GetRealizeBouncedChequeListData = async () => {
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
            startDate
        );
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        if (!selectedBank) {
            toast.warn("Please select bank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        try {
            setLoadigndt(true);
            const response = await createAPIBankingTransaction().get(
                `${EndpointBankingTransaction.GetRealizeBouncedChequeList}?CompId=${auth.CompId}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}&BankID=${selectedBank?.MASK_ACCT_ID}`
            );
            setBouncedChequeList(response.data.Data ?? []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadigndt(false);
        }
    };

    const GetNewDepositChequeListData = async () => {
        try {
            setLoadigndt(true);
            const response = await createAPIBankingTransaction().get(
                `${EndpointBankingTransaction.GetNewDepositChequeList}?CompId=${auth.CompId}`
            );
            setNewDepositChequeList(response.data.Data ?? []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadigndt(false);
        }
    };

    const filterBanks = (event) => {
        let query = event.query.toLowerCase();
        let filtered = bankDetailsData.filter(
            (bank) =>
                bank.BANK_NAME.toLowerCase().includes(query) ||
        bank.BRANCH_NAME.toLowerCase().includes(query) ||
        bank.BANK_ACCOUNT_NO.includes(query)
        );
        setFilteredBanksData(filtered);
    };

    const activeTabIndex = (e) => {
        setTabIndex(e.index);
        setSelectBankrecptData([]);
        setSelectBankChqData([]);
    };

    useEffect(() => {
        getPopulateBankDetailsData();
        GetNewDepositChequeListData();
    }, []);

    const transTrans = (item) => {
        let transtypestring = "";
        switch (item) {
        case 0:
            transtypestring = "Deposit Cheque";
            break;
        case 1:
            transtypestring = "Realized Cheque";
            break;
        case 2:
            transtypestring = "Cheque Bounced";
            break;
        }
        return transtypestring;
    };

    const savebankdata = async () => {
        if (selectedBank == null) {
            toast.warn("Please select bank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (tabIndex == 0) {
            if (selectBankrecptData.length == 0) {
                toast.warn("Please select atleast one receipt", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
        } else if (tabIndex == 1 || tabIndex == 2) {
            if (selectBankChqData.length == 0) {
                toast.warn("Please select atleast one receipt", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
        }

        let depositecq = selectBankrecptData.map((item) => {
            return {
                masK_BANK_RECONC_ID: item.MASK_BANK_RECONC_ID ?? "",
                receirT_NO: item.RECEIRT_NO ?? "",
                receipT_DATE: item.RECEIPT_DATE ?? "",
                chequE_DRAFT_NO: item.CHEQUE_DRAFT_NO ?? "",
                chequE_DRAFT_DATE: item.CHEQUE_DRAFT_DATE ?? "",
                drawN_ON: item.DRAWN_ON ?? "",
                brancH_NAME: item.BRANCH_NAME ?? "",
                accounT_NO: item.ACCOUNT_NO ?? "",
                customeR_NAME: item.CUSTOMER_NAME ?? "",
                amount: item.AMOUNT.toString() ?? "",
                deposited: "Yes",
                masK_PAY_IN_SLIP_NO: item.MASK_PAY_IN_SLIP_NO ?? "",
                masK_PAY_IN_SLIP_DATE: item.MASK_PAY_IN_SLIP_DATE ?? "",
                masK_PAY_MODE: item.MASK_PAY_MODE ?? "",
            };
        });
        let depositchq = selectBankChqData.map((item) => {
            return {
                masK_BANK_RECONC_ID: item.MASK_BANK_RECONC_ID ?? "",
                masK_PARTY_CODE: item.MASK_PARTY_CODE ?? "",
                type: item.TYPE ?? "",
                documenT_NO: item.DOCUMENT_NO ?? "",
                documenT_DATE: item.DOCUMENT_DATE ?? "",
                chequE_DRAFT_NO: item.CHEQUE_DRAFT_NO ?? "",
                chequE_DRAFT_DATE: item.CHEQUE_DRAFT_DATE ?? "",
                accounT_NO: item.ACCOUNT_NO ?? "",
                brancH_NAME: item.BRANCH_NAME ?? "",
                amount: item.AMOUNT ?? "",
                processed: "Yes",
                description: item.DESCRIPTION ?? "",
                masK_PAY_MODE: item.MASK_PAY_MODE ?? "",
            };
        });

        let payload = {
            compId: auth.CompId,
            userId: auth.UserId,
            documentDate: format(transactionDate, "dd/MM/yyyy"),
            bankTransType: transTrans(tabIndex),
            banK_MASK_ID: selectedBank.MASK_ACCT_ID,
            bankName: selectedBank.BANK_NAME,
            allDepositRecords: depositecq,
            allRealizedRecords: depositchq,
        };
        // console.log(payload);
        // return;
        try {
            setLoadigndt(true);
            const response = await createAPIBankingTransaction().post(
                `${EndpointBankingTransaction.SaveBankTransaction}`,
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            // let response=[{}]
            // let response.data={"Status":"Warning","Message":"Data Partially Record(s) saved successfully","Data":[{"ErrorList":" RV/25/26/02459"}]};
            if (response.data.Status == "Warning") {
                let errorlst;
                if (response?.data?.Data?.length !== 0) {
                    errorlst = response?.data?.Data.map((item) => {
                        return item.ErrorList;
                    });
                }
                toast.warn(`${response.data.Message} errors found in - ${errorlst}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 6000,
                });
            } else {
                toast.success(`${response.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
            }
            // console.log(response.data.Message);
            GetNewDepositChequeListData();
            setSelectBankrecptData([]);
            setSelectBankChqData([]);
            setBouncedChequeList([]);
            // GetRealizeBouncedChequeListData();
            setSelectedBank(null);
            // setNewDepositChequeList([]);
        } catch (error) {
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 8000,
            });
            console.log(error);
        } finally {
            setLoadigndt(false);
        }
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mx-1">
                            <li className="breadcrumb-item">
                                <Link to="/creditmanagement/bankingtransactionallrecords">
                  Banking Transaction
                                </Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                Details
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="text-end">
                        <Link to="/creditmanagement/bankingtransactionallrecords">
                            <button type="button" className="btn btn-outline-primary me-3">
                                <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                Records
                            </button>
                        </Link>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={savebankdata}
                        >
              Save
                        </button>
                    </div>
                </div>
            </div>
            <div className="sales-box">
                <div className="row d-flex justify-content-end align-items-end">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label className="form-label">
              Bank Name <span className="mandatory">*</span>
                        </label>
                        <AutoComplete
                            id="bank"
                            value={selectedBank}
                            suggestions={filteredBanksData}
                            completeMethod={filterBanks}
                            field="BANK_NAME"
                            onChange={(e) => {
                                setSelectedBank(e.value);
                                setBouncedChequeList([]);
                            }}
                            dropdown
                            required
                            forceSelection={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3"></div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <label className="form-label">
              Account Number <span className="mandatory">*</span>
                        </label>
                        <InputText
                            className="form-control"
                            value={selectedBank?.BANK_ACCOUNT_NO ?? ""}
                            required
                            disabled
                        />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <label className="form-label">
              Branch <span className="mandatory">*</span>
                        </label>
                        <InputText
                            className="form-control"
                            value={selectedBank?.BRANCH_NAME ?? ""}
                            required
                            disabled
                        />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <label className="form-label">
              Transaction Date <span className="mandatory">*</span>
                        </label>
                        <Calendar
                            value={transactionDate}
                            onChange={(e) => setTransactionDate(e.value)}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                </div>
            </div>
            <>
                {loadigndt ? (
                    <>
                        <Loader />
                    </>
                ) : null}
            </>
            <div className="TabPanel">
                {loader ? (
                    <>
                        <Loader />
                    </>
                ) : (
                    <TabView
                        activeIndex={tabIndex}
                        onTabChange={(e) => activeTabIndex(e)}
                    >
                        <TabPanel header="Deposit Cheque">
                            <section>
                                <div className="col-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={newDepositChequeList}
                                            rows={10}
                                            filterDisplay="row"
                                            // showGridlines
                                            stripedRows
                                            scrollHeight="80vh"
                                            scrollable
                                            paginator
                                            showSelectAll={true}
                                            selectionPageOnly={true}
                                            selection={selectBankrecptData}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            onSelectionChange={(e) => {
                                                setSelectBankrecptData(e.value);
                                            }}
                                            tableStyle={{ minWidth: "80rem" }}
                                        >
                                            <Column
                                                selectionMode="multiple"
                                                header="Select All"
                                                headerStyle={{ width: "5rem" }}
                                            ></Column>
                                            <Column
                                                field="RECEIRT_NO"
                                                header="Receipt Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="RECEIPT_DATE"
                                                header="Receipt Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_NO"
                                                header="Cheque Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_DATE"
                                                header="Cheque Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column field="DRAWN_ON" header="Drawn On"></Column>
                                            <Column
                                                field="CUSTOMER_NAME"
                                                header="Customer Name"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column field="AMOUNT" header="Total Amount"></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        </TabPanel>

                        <TabPanel header="Realized Cheque">
                            <section>
                                <div className="sales-box">
                                    <div className="row d-flex justify-content-end align-items-end">
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label className="form-label">From Date</label>
                                            <Calendar
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.value)}
                                                showIcon
                                                dateFormat="dd/mm/yy"
                                            />
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label className="form-label">To Date</label>
                                            <Calendar
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.value)}
                                                showIcon
                                                dateFormat="dd/mm/yy"
                                            />
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => GetRealizeBouncedChequeListData()}
                                                >
                          Get Data
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={bouncedChequeList}
                                            rows={10}
                                            filterDisplay="row"
                                            // showGridlines
                                            stripedRows
                                            scrollHeight="80vh"
                                            scrollable
                                            paginator
                                            showSelectAll={true}
                                            selectionPageOnly={true}
                                            selection={selectBankChqData}
                                            onSelectionChange={(e) => {
                                                setSelectBankChqData(e.value);
                                            }}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            tableStyle={{ minWidth: "80rem" }}
                                        >
                                            <Column
                                                selectionMode="multiple"
                                                header="Select All"
                                                headerStyle={{ width: "5rem" }}
                                            ></Column>
                                            <Column
                                                field="DOCUMENT_NO"
                                                header="Document Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="DOCUMENT_DATE"
                                                header="Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_NO"
                                                header="Cheque Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_DATE"
                                                header="Cheque Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column field="AMOUNT" header="Amount"></Column>
                                            <Column field="PROCESSED" header="Processed"></Column>
                                            <Column
                                                field="DESCRIPTION"
                                                header="Customer Name"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        </TabPanel>
                        <TabPanel header="Cheque Bounced">
                            <section>
                                <div className="sales-box">
                                    <div className="row d-flex justify-content-end align-items-end">
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label className="form-label">From Date</label>
                                            <Calendar
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.value)}
                                                showIcon
                                                dateFormat="dd/mm/yy"
                                            />
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label className="form-label">To Date</label>
                                            <Calendar
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.value)}
                                                showIcon
                                                dateFormat="dd/mm/yy"
                                            />
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => GetRealizeBouncedChequeListData()}
                                                >
                          Get Data
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={bouncedChequeList}
                                            rows={10}
                                            filterDisplay="row"
                                            stripedRows
                                            scrollHeight="80vh"
                                            scrollable
                                            paginator
                                            showSelectAll={true}
                                            selectionPageOnly={true}
                                            selection={selectBankChqData}
                                            onSelectionChange={(e) => {
                                                setSelectBankChqData(e.value);
                                            }}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            tableStyle={{ minWidth: "80rem" }}
                                        >
                                            <Column
                                                selectionMode="multiple"
                                                header="Select All"
                                                headerStyle={{ width: "5rem" }}
                                            ></Column>
                                            <Column
                                                field="DOCUMENT_NO"
                                                header="Document Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="DOCUMENT_DATE"
                                                header="Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_NO"
                                                header="Cheque Number"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column
                                                field="CHEQUE_DRAFT_DATE"
                                                header="Cheque Date"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column field="AMOUNT" header="Amount"></Column>
                                            <Column field="PROCESSED" header="Processed"></Column>
                                            <Column
                                                field="DESCRIPTION"
                                                header="Customer Name"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        </TabPanel>
                    </TabView>
                )}
            </div>
        </div>
    );
};

export default BankingTransactionDetails;
